import ApiServices from '@/services/api'
import globalMixin from '@/mixins'
let that = globalMixin.methods

// --->>>>>>>>>>>>>>>   Get Open session List api call   <<<<<<<<<<<<<<---
const OPEN_SESSION_LIST = ({
  commit
}) => {
  return ApiServices.getOpenSessionList()
    .then(response => {
      commit('getOpenSessionList', response)
      console.log("getOpenSessionList=====", response)
      // that.SUCCESS_TOAST_MSG(response.message)
    })
}

// --->>>>>>>>>>>>>>>   Get selected session data List api call   <<<<<<<<<<<<<<---
const SELECTED_SESSION_LIST = ({ commit }, data) => {
  return ApiServices.getSelectedSessionList(data)
    .then(response => {
      commit('getSelectedSessionData', response)
      commit('getTotalBillableUnits', response)
      commit('getIncompleteData', response)
      commit('getSuspiciousMessages', response)

      // that.SUCCESS_TOAST_MSG(response.message)
    })
}

const OUTLIER_SESSION_LIST = ({ commit }, data) => {
  return ApiServices.getOutlierSessionList(data)
    .then(response => {
      commit('getOutlierSessionData', response)
    })
}

// --->>>>>>>>>>>>>>>   Get completed session data List api call   <<<<<<<<<<<<<<---
const COMPLETED_SESSION_LIST = ({ commit }, data) => {
  console.log(data, '^^^^^^^^^^^^^^Store')
  return ApiServices.getCompletedSessionList(data)
    .then(response => {
      commit('getCompletedSessionData', response)
      console.log("getCompletedSessionData=====", response)
      // that.SUCCESS_TOAST_MSG(response.message)
    })
}

// --->>>>>>>>>>>>>>>   Get completed session lot List api call   <<<<<<<<<<<<<<---
const COMPLETED_SESSION_LOTS = ({
  commit
}, data) => {
  return ApiServices.getCompletedSessionLots(data)
    .then(response => {
      commit('getCompletedSessionLots', response)
      // console.log("getCompletedSessionLots=====", response)
      // that.SUCCESS_TOAST_MSG(response.message)
    })
}

const COMMON_CONSUMPTION_HISTORY = ({
  commit
}, data) => {
  return ApiServices.getCommonConsumption(data)
    .then(response => {
      commit('getCommonConsumptionHistory', response)
      return response
    })
}

// --->>>>>>>>>>>>>>>   Get adhoc session data List api call   <<<<<<<<<<<<<<---
const ADHOC_SESSION_LIST = ({
  commit
}, data) => {
  return ApiServices.getAdhocSessionList(data)
    .then(response => {
      commit('getAdhocSessionData', response)
      console.log("getAdhocSessionData=====", response)
      // that.SUCCESS_TOAST_MSG(response.message)
    })
}

// --->>>>>>>>>>>>>>>   Get adhoc session lot List api call   <<<<<<<<<<<<<<---
const ADHOC_SESSION_LOTS = ({
  commit
}, data) => {
  return ApiServices.getAdhocSessionLots(data)
    .then(response => {
      commit('getAdhocSessionLots', response)
      // console.log("getAdhocSessionLots=====", response)
      // that.SUCCESS_TOAST_MSG(response.message)
    })
}

// --->>>>>>>>>>>>>>>   Get adhoc session lot List api call   <<<<<<<<<<<<<<---
const GET_BILL_VALUE = ({
  commit
}, data) => {
  return ApiServices.getBillValue(data)
    .then(response => {
      commit('getBillValue', response)
      // console.log("getAdhocSessionLots=====", response)
      // that.SUCCESS_TOAST_MSG(response.message)
    })
}

// --->>>>>>>>>>>>>>>   Get selected session data List api call   <<<<<<<<<<<<<<---
const SESSION_UPLOAD = ({
  commit
}, data) => {
  return ApiServices.uploadSessionData(data)
    .then(response => {
      commit('uploadSession', response)
      // console.log("getCompletedSessionLots=====", response)
      that.SUCCESS_TOAST_MSG(response.message)
    })
}

// --->>>>>>>>>>>>>>>   CLOSED session data List api call   <<<<<<<<<<<<<<---
const CLOSED_SESSION = ({
  commit
}, data) => {
  return ApiServices.closedSession(data)
    .then(response => {
      commit('closedSession', response)
      console.log("closedSession=====", response)
      that.SUCCESS_TOAST_MSG(response.message)
    })
}

// --->>>>>>>>>>>>>>>   DISCARD session data List api call   <<<<<<<<<<<<<<---
const DISCARD_SESSION = ({
  commit
}, data) => {
  return ApiServices.discardSession(data)
    .then(response => {
      commit('discardSession', response)
      console.log("discardSession=====", response)
      that.SUCCESS_TOAST_MSG(response.message)
    })
}

const SUPPORT_BOWSER_ALLOCATION = ({
  commit
}, data) => {
  return ApiServices.supportBowserAllocation(data)
}
const COMPLETED_SESSION_MAIL = ({
  commit
}, data) => {
  return ApiServices.completedSessionMail(data)
    .then(response => {
      that.SUCCESS_TOAST_MSG(response.message)
    })
};
const COMPLETED_SESSION_MAIL_ANOTHER = ({
  commit
}, data) => {
  return ApiServices.completedSessionMailAnother(data)
    .then(response => {
      that.SUCCESS_TOAST_MSG(response.message)
    })
};
const CRON_BILL_RATE_EMAIL_TRIGGER = ({
  commit
}) => {
  return ApiServices.cronBillRate()
    .then(response => {
      that.SUCCESS_TOAST_MSG(response.message)
    })
};
const CRON_ANOTHER = ({
  commit
}) => {
  return ApiServices.cronAnother()
    .then(response => {
      that.SUCCESS_TOAST_MSG(response.message)
    })
};
const ADHOC_SESSION_MAIL = ({
  commit
}, data) => {
  return ApiServices.adhocSessionMail(data)
    .then(response => {
      that.SUCCESS_TOAST_MSG(response.message)
    })
}


// --->>>>>>>>>>>>>>>   update current usnit  <<<<<<<<<<<<<<---
const UPDATE_CURRENT_UNIT = ({
  commit
}, data) => {
  return ApiServices.updateCurrentUnit(data)
    .then(response => {
      commit('getOpenSessionList', response)
      console.log("getOpenSessionList=====", response)
      // that.SUCCESS_TOAST_MSG(response.message)
    })
}

// --->>>>>>>>>>>>>>>   Auto complete missing lots  <<<<<<<<<<<<<<---
const AUTO_COMPLETED_MISSING_LOTS = ({
  commit
}, data) => {
  return ApiServices.autoCompleteMissingLots(data)
    .then(response => {
      // commit('autoCompleteMissingLots', response)
      // console.log("autoCompleteMissingLots=====", response)
      return response
    })
}

export default {
  OPEN_SESSION_LIST,
  SELECTED_SESSION_LIST,
  OUTLIER_SESSION_LIST,
  COMPLETED_SESSION_LIST,
  COMPLETED_SESSION_LOTS,
  COMMON_CONSUMPTION_HISTORY,
  ADHOC_SESSION_LIST,
  ADHOC_SESSION_LOTS,
  GET_BILL_VALUE,
  SESSION_UPLOAD,
  CLOSED_SESSION,
  DISCARD_SESSION,
  SUPPORT_BOWSER_ALLOCATION,
  COMPLETED_SESSION_MAIL,
  COMPLETED_SESSION_MAIL_ANOTHER,
  CRON_ANOTHER,
  CRON_BILL_RATE_EMAIL_TRIGGER,
  ADHOC_SESSION_MAIL,
  AUTO_COMPLETED_MISSING_LOTS,
  UPDATE_CURRENT_UNIT
}



// WEBPACK FOOTER //
// ./src/store/modules/sessions/actions.js